export default "/_next/static/chunks/fonts/WhitneySSm-Bold-Pro_Web-1312527d1a527dbd1ad017f2c943333b.woff";